// Presentation only: never replace stored school values or identity/filter keys.
export function schoolDisplayName(value, academyInfo = {}) {
  const original = String(value || "");
  const known = academyInfo.schools?.find(school =>
    original === `${school.name} (${school.city} ${school.district})`
  );
  if (known) return known.name;
  return original.replace(/\s*\((?:서울특별시|부산광역시|대구광역시|인천광역시|광주광역시|대전광역시|울산광역시|세종특별자치시|경기도|강원도|강원특별자치도|충청북도|충청남도|전라북도|전북특별자치도|전라남도|경상북도|경상남도|제주도|제주특별자치도)(?:\s+[^()]*)?\)$/, "");
}

// Payment RPC returns school + grade in one label. Preserve the grade suffix.
export function schoolDisplayWithGrade(value, academyInfo = {}) {
  const original = String(value || "");
  const grade = original.match(/\s+\d+학년$/)?.[0] || "";
  return schoolDisplayName(grade ? original.slice(0, -grade.length) : original, academyInfo) + grade;
}
